import { render, staticRenderFns } from "./userLinkBtn.vue?vue&type=template&id=ba8f10b6"
import script from "./userLinkBtn.vue?vue&type=script&lang=js"
export * from "./userLinkBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports